module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container__left"
  }, [_c('div', {
    staticClass: "canvas-toolbar canvas-toolbar--left panzoom-exclude"
  }, [_c('div', {
    staticClass: "canvas-tool-group"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "canvas-icon-btn",
    attrs: {
      "type": "button",
      "title": "Fit to screen"
    },
    on: {
      "click": _vm.fitToScreen
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "canvas-tool-group canvas-search",
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.moveStageResult(1)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.moveStageResult(-1)
      }]
    }
  }, [_c('i', {
    staticClass: "fa fa-search canvas-search__icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stageQuery),
      expression: "stageQuery"
    }],
    staticClass: "canvas-search__input",
    attrs: {
      "type": "text",
      "placeholder": "Find stage or message",
      "aria-label": "Find stage or message",
      "data-nv-ignore-dirty": ""
    },
    domProps: {
      "value": (_vm.stageQuery)
    },
    on: {
      "focus": _vm.openStageSearch,
      "blur": _vm.closeStageSearch,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        _vm.stageResults[_vm.stageResultIndex] && _vm.goToStage(_vm.stageResults[_vm.stageResultIndex].name)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.stageQuery = ''
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stageQuery = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.stageSearchOpen && _vm.stageQuery) ? _c('ul', {
    staticClass: "canvas-search__results"
  }, [_vm._l((_vm.stageResults), function(result, i) {
    return _c('li', {
      key: result.name,
      staticClass: "canvas-search__result",
      class: {
        'canvas-search__result--active': i === _vm.stageResultIndex
      },
      attrs: {
        "title": result.name
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          return _vm.goToStage(result.name)
        },
        "mouseenter": function($event) {
          _vm.stageResultIndex = i
        }
      }
    }, [_c('div', {
      staticClass: "canvas-search__name"
    }, [_vm._v(_vm._s(result.name))]), _vm._v(" "), (result.snippet) ? _c('div', {
      staticClass: "canvas-search__snippet"
    }, [_c('span', {
      staticClass: "canvas-search__where"
    }, [_vm._v(_vm._s(result.where))]), _vm._v("\n              " + _vm._s(result.snippet.before)), _c('mark', [_vm._v(_vm._s(result.snippet.match))]), _vm._v(_vm._s(result.snippet.after) + "\n            ")]) : _vm._e()])
  }), _vm._v(" "), (!_vm.stageResults.length) ? _c('li', {
    staticClass: "canvas-search__result canvas-search__result--empty"
  }, [_vm._v("No stage, message or PF matches \"" + _vm._s(_vm.stageQuery) + "\"")]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "canvas-tool-group"
  }, [_c('label', {
    staticClass: "canvas-toggle",
    class: {
      'canvas-toggle--on': _vm.toggleOptionLabelSwitch
    },
    attrs: {
      "title": "Show the option text on each arrow"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toggleOptionLabelSwitch),
      expression: "toggleOptionLabelSwitch"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.toggleOptionLabelSwitch) ? _vm._i(_vm.toggleOptionLabelSwitch, null) > -1 : (_vm.toggleOptionLabelSwitch)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.toggleOptionLabelSwitch,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toggleOptionLabelSwitch = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toggleOptionLabelSwitch = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toggleOptionLabelSwitch = $$c
        }
      }, _vm.handleOptionLabelToggle]
    }
  }), _vm._v(" "), _vm._m(2), _vm._v("\n          Options\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "canvas-toggle",
    class: {
      'canvas-toggle--on': _vm.toggleMessagesSwitch
    },
    attrs: {
      "title": "Show each stage's messages, PF, recommendations, delays, nudges and other settings inside the stage"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toggleMessagesSwitch),
      expression: "toggleMessagesSwitch"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.toggleMessagesSwitch) ? _vm._i(_vm.toggleMessagesSwitch, null) > -1 : (_vm.toggleMessagesSwitch)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.toggleMessagesSwitch,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toggleMessagesSwitch = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toggleMessagesSwitch = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toggleMessagesSwitch = $$c
        }
      }, _vm.handleMessagesToggle]
    }
  }), _vm._v(" "), _vm._m(3), _vm._v("\n          Messages\n        ")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.query.app),
      expression: "this.$route.query.app"
    }],
    staticClass: "canvas-toggle",
    class: {
      'canvas-toggle--on': _vm.toggleTrafficSwitch
    },
    attrs: {
      "title": "How many users moved between stages. Traffic data starts from 16-Mar-2022."
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toggleTrafficSwitch),
      expression: "toggleTrafficSwitch"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.toggleTrafficSwitch) ? _vm._i(_vm.toggleTrafficSwitch, null) > -1 : (_vm.toggleTrafficSwitch)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.toggleTrafficSwitch,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toggleTrafficSwitch = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toggleTrafficSwitch = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toggleTrafficSwitch = $$c
        }
      }, _vm.handleTrafficToggle]
    }
  }), _vm._v(" "), _vm._m(4), _vm._v("\n          Traffic\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "canvas-toolbar canvas-toolbar--right panzoom-exclude"
  }, [_c('div', {
    staticClass: "canvas-export",
    on: {
      "focusout": _vm.closeExportMenu
    }
  }, [_c('button', {
    staticClass: "canvas-btn",
    class: {
      'canvas-btn--active': _vm.exportMenuOpen
    },
    attrs: {
      "type": "button",
      "title": "Download the graph as it's shown now",
      "disabled": _vm.exporting
    },
    on: {
      "click": function($event) {
        _vm.exportMenuOpen = !_vm.exportMenuOpen
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.exporting ? 'fa-circle-o-notch fa-spin' : 'fa-download',
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Export\n        ")]), _vm._v(" "), (_vm.exportMenuOpen) ? _c('ul', {
    staticClass: "canvas-export__menu"
  }, [_c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exportGraph('html')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Interactive HTML")])]), _vm._v(" "), _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exportGraph('png')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PNG image")])]), _vm._v(" "), _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exportGraph('svg')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-code-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" SVG (scalable)")])])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "canvas-btn",
    class: {
      'canvas-btn--active': _vm.showLegend
    },
    attrs: {
      "id": "legend",
      "type": "button",
      "title": "Show legend"
    },
    on: {
      "click": function($event) {
        _vm.showLegend = !_vm.showLegend
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Legend\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "canvas-btn canvas-btn--primary",
    attrs: {
      "id": "validateconversation",
      "type": "button",
      "title": 'Validate & Save ' + _vm.conversationType
    },
    on: {
      "click": _vm.validateConversation
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Validate & Save\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLegend),
      expression: "showLegend"
    }],
    staticClass: "conversation-graph-legend panzoom-exclude",
    on: {
      "wheel": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "conversation-graph-legend__header"
  }, [_c('span', [_vm._v("Legend")]), _vm._v(" "), _c('button', {
    staticClass: "canvas-icon-btn canvas-icon-btn--plain",
    attrs: {
      "type": "button",
      "title": "Close legend"
    },
    on: {
      "click": function($event) {
        _vm.showLegend = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "conversationLegend"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "canvas-hint panzoom-exclude"
  }, [_vm._v("\n      Double-click a stage to open it · Right-click to edit or delete · Drag to move · Scroll to zoom\n    ")]), _vm._v(" "), (_vm.clickHint) ? _c('div', {
    staticClass: "canvas-click-hint",
    style: ({
      left: _vm.clickHint.x + 'px',
      top: _vm.clickHint.y + 'px'
    })
  }, [_c('i', {
    staticClass: "fa fa-mouse-pointer",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Double-click to open\n    ")]) : _vm._e(), _vm._v(" "), (_vm.drawingVisible) ? _c('div', {
    staticClass: "canvas-status panzoom-exclude"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Drawing graph…\n    ")]) : _vm._e(), _vm._v(" "), (_vm.layoutError) ? _c('div', {
    staticClass: "canvas-error panzoom-exclude"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(5)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "conversation-tree-container",
    class: {
      'conversation-tree-container--stale': _vm.drawingVisible
    },
    attrs: {
      "id": "conversationTreeContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "conversationTreeSvg"
    },
    on: {
      "contextmenu": function($event) {
        $event.preventDefault();
        return _vm.handleRightClick($event)
      },
      "mousedown": _vm.rememberPointer,
      "click": _vm.handleStageClick,
      "dblclick": _vm.handleStageDoubleClick
    }
  })]), _vm._v(" "), (_vm.processing) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "canvas-icon-btn",
    attrs: {
      "id": "zoomin",
      "type": "button",
      "title": "Zoom in"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "canvas-icon-btn",
    attrs: {
      "id": "zoomout",
      "type": "button",
      "title": "Zoom out"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "canvas-toggle__track"
  }, [_c('span', {
    staticClass: "canvas-toggle__thumb"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "canvas-toggle__track"
  }, [_c('span', {
    staticClass: "canvas-toggle__thumb"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "canvas-toggle__track"
  }, [_c('span', {
    staticClass: "canvas-toggle__thumb"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("Couldn't draw this graph")]), _vm._v(" "), _c('p', [_vm._v("It may be too large for the graph engine. You can still use Find stage to open any stage.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-06c70cb0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/conversationTreeView.vue
// module id = Di+S
// module chunks = 1